/* eslint-disable prettier/prettier */

export const merchantManufacturerOrImporterTypes = [
  'MANUFACTURER_OR_IMPORTER_AS_TAX_WAREHOUSE',
  'MANUFACTURER_OR_IMPORTER_AS_SIMPLIFIED_TAX_WAREHOUSE',
  'MANUFACTURER_OR_IMPORTER_AS_SMALL_SCALE_WINE_PRODUCER',
] as const;

export const merchantInternationalTraderTypes = [
  'INTERNATIONAL_TRADER_AS_REGISTERED_DEALER',
  'INTERNATIONAL_TRADER_AS_COMMUNITY_EXCISE_WHOLESALER',
  'INTERNATIONAL_TRADER_AS_EXPORT_IMPORT_WHOLESALER',
] as const;

export const merchantWholesalerType = 'WHOLESALER_AS_IS' as const;

export const merchantRetailerTypes = [
  'RETAILER_AS_HOTEL',
  'RETAILER_AS_RESTAURANT',
  'RETAILER_AS_CAFE',
  'RETAILER_AS_RETAIL_CHAIN',
  'RETAILER_AS_TRAFIK',
  'RETAILER_AS_OTHER_RETAILER',
] as const;

export const merchantTypes = [
  ...merchantManufacturerOrImporterTypes,
  ...merchantInternationalTraderTypes,
  merchantWholesalerType,
  ...merchantRetailerTypes,
] as const;

export type MerchantType = typeof merchantTypes[number];
